import keyMirror from "keymirror";


const TrainingConstants = {
	ActionTypes: keyMirror({
		
		// course-library
		CHANGETRAININGCOURSE: null,
		SELECTTRAININGCOURSE: null,
		// internal-course
		CHANGEINTERNALCOURSE: null,
		SELECTINTERNALCOURSE: null,
		UPDATEINTERNALCOURSE: null,
		// external-course
		CHANGEEXTERNALCOURSE: null,
		SELECTEXTERNALCOURSE: null,
		UPDATEEXTERNALCOURSE: null,
		// newcomer-training

	})
}


export default TrainingConstants;


// WEBPACK FOOTER //
// ./src/constants/training-constants.js